import PropTypes from 'prop-types'

import Brt from './../../assets/mp-brt-icon.svg'
import Bus from './../../assets/mp-bus-icon.svg'
import CarRepair from './../../assets/mp-carRepair-icon.svg'
import Entertainment from './../../assets/mp-entertainment-icon.svg'
import FireStation from './../../assets/mp-fireStation-icon.svg'
import Highway from './../../assets/mp-highway-icon.svg'
import Hospital from './../../assets/mp-hospital-icon.svg'
import Institute from './../../assets/mp-institute-icon.svg'
import Metro from './../../assets/mp-metro-icon.svg'
import OilStation from './../../assets/mp-oilStation-icon.svg'
import Park from './../../assets/mp-park-icon.svg'
import Police from './../../assets/mp-police-icon.svg'
import Pool from './../../assets/mp-pool-icon.svg'
import Road from './../../assets/mp-road-icon.svg'
import RoadCamera from './../../assets/mp-roadCamera-icon.svg'
import School from './../../assets/mp-school-icon.svg'
import Shop from './../../assets/mp-shop-icon.svg'
import Sport from './../../assets/mp-sport-icon.svg'
import Taxi from './../../assets/mp-taxi-icon.svg'

const MpIcon = ({name , size }) => {

    if(name === "brt" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-blue ">
                <img src={Brt} alt="" />
            </div> 
    else if(name === "brt" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-blue ">
                <img src={Brt} alt="" />
            </div> 



    else if(name === "bus" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-blue ">
                <img src={Bus} alt="" />
            </div> 
    else if(name === "bus" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-blue ">
                <img src={Bus} alt="" />
            </div> 



    else if(name === "carRepair" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={CarRepair} alt="" />
            </div> 
    else if(name === "carRepair" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={CarRepair} alt="" />
            </div> 



    else if(name === "entertainment" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-blue ">
                <img src={Entertainment} alt="" />
            </div> 
    else if(name === "entertainment" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-blue ">
                <img src={Entertainment} alt="" />
            </div> 



    else if(name === "fireStation" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-red ">
                <img src={FireStation} alt="" />
            </div> 
    else if(name === "fireStation" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-red ">
                <img src={FireStation} alt="" />
            </div> 



    else if(name === "highway" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={Highway} alt="" />
            </div> 
    else if(name === "highway" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={Highway} alt="" />
            </div> 



    else if(name === "hospital" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-red ">
                <img src={Hospital} alt="" />
            </div> 
    else if(name === "hospital" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-red ">
                <img src={Hospital} alt="" />
            </div> 



    else if(name === "institute" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={Institute} alt="" />
            </div> 
    else if(name === "institute" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={Institute} alt="" />
            </div> 



    else if(name === "metro" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-blue ">
                <img src={Metro} alt="" />
            </div> 
    else if(name === "metro" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-blue ">
                <img src={Metro} alt="" />
            </div> 



    else if(name === "oilStation" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={OilStation} alt="" />
            </div> 
    else if(name === "oilStation" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={OilStation} alt="" />
            </div> 



    else if(name === "park" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-green ">
                <img src={Park} alt="" />
            </div> 
    else if(name === "park" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-green ">
                <img src={Park} alt="" />
            </div> 



    else if(name === "police" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={Police} alt="" />
            </div> 
    else if(name === "police" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={Police} alt="" />
            </div> 



    else if(name === "pool" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-blue ">
                <img src={Pool} alt="" />
            </div> 
    else if(name === "pool" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-blue ">
                <img src={Pool} alt="" />
            </div> 



    else if(name === "road" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={Road} alt="" />
            </div> 
    else if(name === "road" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={Road} alt="" />
            </div> 



    else if(name === "roadCamera" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={RoadCamera} alt="" />
            </div> 
    else if(name === "roadCamera" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={RoadCamera} alt="" />
            </div> 



    else if(name === "school" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={School} alt="" />
            </div> 
    else if(name === "school" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={School} alt="" />
            </div> 



    else if(name === "shop" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={Shop} alt="" />
            </div> 
    else if(name === "shop" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={Shop} alt="" />
            </div> 



    else if(name === "sport" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-blue ">
                <img src={Sport} alt="" />
            </div> 
    else if(name === "sport" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-blue ">
                <img src={Sport} alt="" />
            </div> 



    else if(name === "taxi" && size ==="sm") 
    return <div className="mp-icon mp-icon-sm mp-icon-yellow ">
                <img src={Taxi} alt="" />
            </div> 
    else if(name === "taxi" && size ==="bg")
    return <div className="mp-icon mp-icon-bg mp-icon-yellow ">
                <img src={Taxi} alt="" />
            </div> 
}

export default MpIcon

MpIcon.propTypes = {
    name: PropTypes.string,
    size: PropTypes.string,
  };

MpIcon.defaultProps = {
    name: "brt",
    size: "sm",
  };